/* VUERRA theme script. No dependencies. */
(() => {
  'use strict';

  const A = window.Vuerra || (window.Vuerra = {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const MINUS = '−';
  const fmtPower = (n) => (n > 0 ? '+' : n < 0 ? MINUS : '') + Math.abs(n).toFixed(2);

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    format = format || A.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    const ph = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (n, precision, thousands = ',', decimal = '.') => {
      const fixed = (n / 100).toFixed(precision).split('.');
      return fixed[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (fixed[1] ? decimal + fixed[1] : '');
    };
    const m = format.match(ph);
    if (!m) return format;
    let v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(ph, v);
  }
  const money = (cents) => formatMoney(cents).replace(/[.,]00(?=\D*$)/, '');
  A.money = money;

  const sizedImg = (url, w) => {
    if (!url) return '';
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url + (url.includes('?') ? '&' : '?') + 'width=' + w;
    return url;
  };

  /* ---------- preview mode (static demo outside Shopify) ---------- */
  const Preview = (() => {
    const cat = $('#VuerraPreviewCatalog');
    if (!cat) return null;
    const catalog = JSON.parse(cat.textContent);
    const KEY = 'vuerra-preview-cart';
    let items = [];
    try { items = JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) { items = []; }
    const save = () => { try { sessionStorage.setItem(KEY, JSON.stringify(items)); } catch (e) { /* storage unavailable */ } };
    const findVariant = (id) => {
      for (const p of Object.values(catalog)) { const v = p.variants.find((x) => String(x.id) === String(id)); if (v) return { p, v }; }
      return null;
    };
    const build = () => {
      const lines = items.map((it) => {
        const f = findVariant(it.id); if (!f) return null;
        const { p, v } = f;
        let price = v.price, plan = null;
        if (it.plan) {
          const alloc = (v.selling_plan_allocations || []).find((a) => String(a.selling_plan_id) === String(it.plan));
          if (alloc) { price = alloc.price; plan = { selling_plan: { name: alloc.plan_name || 'Refresh plan' } }; }
        }
        return {
          key: it.id + ':' + (it.plan || ''), id: v.id, quantity: it.qty, product_title: p.title,
          variant_title: v.title === 'Default Title' ? null : v.title, url: p.url + '?variant=' + v.id,
          image: (v.featured_image && v.featured_image.src) || p.featured_image, price, original_price: v.price,
          final_line_price: price * it.qty, original_line_price: v.price * it.qty, selling_plan_allocation: plan, handle: p.handle
        };
      }).filter(Boolean);
      return {
        items: lines, item_count: lines.reduce((a, l) => a + l.quantity, 0),
        total_price: lines.reduce((a, l) => a + l.final_line_price, 0)
      };
    };
    return {
      catalog,
      cart: () => build(),
      add(id, qty, plan) {
        const ex = items.find((i) => String(i.id) === String(id) && String(i.plan || '') === String(plan || ''));
        if (ex) ex.qty += qty; else items.push({ id, qty, plan: plan || null });
        save();
      },
      change(key, qty) {
        const [id, plan] = key.split(':');
        const i = items.findIndex((x) => String(x.id) === id && String(x.plan || '') === plan);
        if (i > -1) { if (qty <= 0) items.splice(i, 1); else items[i].qty = qty; }
        save();
      },
      product: (handle) => catalog[handle]
    };
  })();
  A.preview = Preview;

  /* ---------- cart ---------- */
  const routes = A.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  const rootPath = routes.root && routes.root !== '/' ? routes.root.replace(/\/$/, '') : '';
  const Cart = {
    state: null,
    async fetch() {
      this.state = Preview ? Preview.cart() : await (await fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })).json();
      CartUI.render(this.state);
      return this.state;
    },
    async addForm(formData) {
      if (Preview) {
        Preview.add(formData.get('id'), Number(formData.get('quantity') || 1), formData.get('selling_plan'));
        return;
      }
      const r = await fetch(routes.cartAdd + '.js', { method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await r.json();
      if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add this item.');
      return data;
    },
    async addVariant(id, qty = 1) {
      const fd = new FormData(); fd.append('id', id); fd.append('quantity', qty);
      return this.addForm(fd);
    },
    async change(key, quantity) {
      if (Preview) { Preview.change(key, quantity); return; }
      const r = await fetch(routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      if (!r.ok) throw new Error('Could not update your bag.');
    },
    async product(handle) {
      if (Preview) return Preview.product(handle);
      const r = await fetch(`${rootPath}/products/${handle}.js`);
      return r.ok ? r.json() : null;
    }
  };
  A.cart = Cart;

  const CartUI = {
    upsell: null,
    async loadUpsell() {
      if (!A.upsellHandle || this.upsell !== null) return;
      try { this.upsell = (await Cart.product(A.upsellHandle)) || false; } catch (e) { this.upsell = false; }
    },
    render(cart) {
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
      const drawer = $('#CartDrawer'); if (!drawer) return;
      const body = $('[data-cart-body]', drawer), foot = $('[data-cart-foot]', drawer);
      $('[data-cart-title-count]', drawer).textContent = cart.item_count ? `(${cart.item_count})` : '';
      if (!cart.items.length) {
        body.innerHTML = `<div class="drawer__empty"><p class="t-h3">Your bag is empty.</p><p class="t-muted">Pick a lens and a power to get started.</p><a class="btn" href="${esc(drawer.dataset.shopUrl || '/products/vuerra-lenses')}">Shop lenses</a></div>`;
        foot.hidden = true;
        return;
      }
      foot.hidden = false;
      const threshold = Number(A.freeShipping) || 0;
      let meter = '';
      if (threshold > 0) {
        const left = threshold - cart.total_price;
        const pct = clamp((cart.total_price / threshold) * 100, 4, 100);
        meter = `<div class="ship-meter" role="status">${left > 0 ? `<span>You're <strong>${money(left)}</strong> away from free US shipping.</span>` : '<span><strong>Your order ships free.</strong></span>'}<div class="ship-meter__bar"><i style="--w:${pct}%"></i></div></div>`;
      }
      const lines = cart.items.map((it) => {
        const plan = it.selling_plan_allocation ? `<span class="line__plan">${esc(it.selling_plan_allocation.selling_plan.name)}</span>` : '';
        const was = it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : '';
        return `<div class="line" data-key="${esc(it.key)}">
          <a class="line__img" href="${esc(it.url)}">${it.image ? `<img src="${esc(sizedImg(it.image, 200))}" alt="" width="84" height="105" loading="lazy">` : ''}</a>
          <div>
            <a class="line__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
            ${it.variant_title ? `<div class="line__meta">${esc(it.variant_title)}</div>` : ''}
            ${plan}
            <div><span class="qty"><button type="button" data-qty="-1" aria-label="Remove one">&minus;</button><span>${it.quantity}</span><button type="button" data-qty="1" aria-label="Add one">+</button></span><button type="button" class="line__remove" data-remove>Remove</button></div>
          </div>
          <div class="line__price">${was}${money(it.final_line_price)}</div>
        </div>`;
      }).join('');
      let upsell = '';
      const u = this.upsell;
      if (u && !cart.items.some((i) => i.handle === u.handle || (u.variants && u.variants.some((v) => v.id === i.id)))) {
        const v = u.variants && u.variants.find((x) => x.available !== false);
        if (v) {
          const img = (u.featured_image && (u.featured_image.src || u.featured_image)) || '';
          upsell = `<div class="upsell">${img ? `<img src="${esc(sizedImg(typeof img === 'string' ? img : img.src, 160))}" alt="" width="64" height="80" loading="lazy">` : '<span></span>'}<div><div class="upsell__title">${esc(drawer.dataset.upsellHeading || 'Add a folio')}</div><div class="upsell__meta">${esc(u.title)}</div></div><button type="button" class="btn btn--s btn--ghost" data-upsell-add="${v.id}">Add ${money(v.price)}</button></div>`;
        }
      }
      body.innerHTML = meter + lines + upsell;
      $('[data-cart-subtotal]', drawer).textContent = money(cart.total_price);
    },
    bind() {
      const drawer = $('#CartDrawer'); if (!drawer) return;
      drawer.addEventListener('click', async (e) => {
        const line = e.target.closest('[data-key]');
        const q = e.target.closest('[data-qty]');
        const rm = e.target.closest('[data-remove]');
        const up = e.target.closest('[data-upsell-add]');
        try {
          if (line && (q || rm)) {
            const it = Cart.state.items.find((i) => String(i.key) === line.dataset.key);
            const next = rm ? 0 : it.quantity + Number(q.dataset.qty);
            line.style.opacity = '.5';
            await Cart.change(line.dataset.key, Math.max(0, next));
            await Cart.fetch();
          } else if (up) {
            up.classList.add('is-loading');
            await Cart.addVariant(up.dataset.upsellAdd, 1);
            await Cart.fetch();
          }
        } catch (err) { console.error(err); await Cart.fetch(); }
      });
    }
  };

  /* ---------- drawers ---------- */
  const Drawer = {
    last: null,
    open(id) {
      const d = document.getElementById(id); if (!d) return;
      this.last = document.activeElement;
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      const f = $('[data-autofocus]', d) || $('button, a[href], input', d);
      setTimeout(() => f && f.focus({ preventScroll: true }), 60);
    },
    close(d) {
      if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
      if (this.last) this.last.focus({ preventScroll: true });
    }
  };
  A.drawer = Drawer;
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      const id = opener.dataset.openDrawer;
      if (id === 'CartDrawer' && A.cartType === 'page') return;
      e.preventDefault();
      if (id === 'CartDrawer') Cart.fetch();
      Drawer.open(id);
      return;
    }
    const closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); Drawer.close(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { const d = $('.drawer.is-open'); if (d) Drawer.close(d); const m = $('.mobile-menu.is-open'); if (m) Menu.close(); }
  });

  /* ---------- header + menu ---------- */
  const header = $('[data-header]');
  // the floating capsule turns to dark glass while it sits over a midnight section
  const DARK = '.section--dark, .seq, .xv, .footer, .ctab--dark, .bhero.is-dark';
  let headerTick = false;
  const onScrollHeader = () => {
    headerTick = false;
    if (!header) return;
    const scrolled = window.scrollY > 44;
    header.classList.toggle('is-scrolled', scrolled);
    const y = header.getBoundingClientRect().top + header.offsetHeight / 2;
    const dark = $$(DARK).some((el) => { const r = el.getBoundingClientRect(); return r.top <= y && r.bottom >= y && r.height > 0; });
    header.classList.toggle('on-dark', dark);
  };
  window.addEventListener('scroll', () => { if (!headerTick) { headerTick = true; requestAnimationFrame(onScrollHeader); } }, { passive: true });
  window.addEventListener('resize', onScrollHeader);
  onScrollHeader();
  const Menu = {
    el: $('#MobileMenu'),
    open() { if (!this.el) return; this.el.classList.add('is-open'); document.body.classList.add('is-locked'); $('[data-menu-close]', this.el).focus(); },
    close() { if (!this.el) return; this.el.classList.remove('is-open'); document.body.classList.remove('is-locked'); const t = $('[data-menu-open]'); t && t.focus(); }
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-open]')) Menu.open();
    else if (e.target.closest('[data-menu-close]')) Menu.close();
  });

  /* ---------- hero: magnifier lens over a near vision chart ---------- */
  function initHero(root) {
    const stage = $('[data-lens-stage]', root);
    const chart = $('[data-chart]', root);
    const lens = $('[data-lens]', root);
    const caustic = $('[data-caustic]', root);
    const content = $('[data-lens-content]', root);
    if (!stage || !chart || !lens) return;
    const K = parseFloat(root.dataset.mag || '1.6');

    const clone = chart.cloneNode(true);
    clone.removeAttribute('id'); clone.setAttribute('aria-hidden', 'true'); clone.removeAttribute('data-chart');
    $$('h1,h2,h3,p', clone).forEach((el) => { const d = document.createElement('div'); d.className = el.className; d.innerHTML = el.innerHTML; el.replaceWith(d); });
    $$('a,button', clone).forEach((el) => el.setAttribute('tabindex', '-1'));
    content.appendChild(clone);

    let W = 0, H = 0, lw = 0, lh = 0, ox = 0, oy = 0;
    let x = 0, y = 0, tx = 0, ty = 0, raf = 0, dragging = false, grab = { x: 0, y: 0 }, hovering = false;
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    const measure = () => {
      W = stage.clientWidth; H = stage.clientHeight; lw = lens.offsetWidth; lh = lens.offsetHeight;
      ox = chart.offsetLeft; oy = chart.offsetTop;
      content.style.width = chart.offsetWidth + 'px';
      if (caustic) { caustic.style.width = lw + 'px'; }
    };
    const rest = () => {
      const el = $('[data-lens-rest]', chart) || chart.lastElementChild;
      const er = el.getBoundingClientRect(), sr = stage.getBoundingClientRect();
      const textEl = $('.chart__text', el) || el;
      const trr = textEl.getBoundingClientRect();
      const px = trr.left - sr.left + Math.min(trr.width * 0.42, lw * 0.95);
      return { x: clamp(px, lw * 0.5, W - lw * 0.5), y: er.top - sr.top + er.height * 0.5 };
    };
    const bounds = (px, py) => ({ x: clamp(px, lw * 0.3, W - lw * 0.3), y: clamp(py, lh * 0.3, H - lh * 0.3) });
    const draw = () => {
      lens.style.transform = `translate3d(${(x - lw / 2).toFixed(2)}px, ${(y - lh / 2).toFixed(2)}px, 0)`;
      if (caustic) caustic.style.transform = `translate3d(${(x - lw / 2 + lw * 0.1).toFixed(2)}px, ${(y - lh / 2 + lh * 0.38).toFixed(2)}px, 0) scale(.9)`;
      const cx = x - ox, cy = y - oy;
      content.style.transform = `translate3d(${(lw / 2 - cx * K).toFixed(2)}px, ${(lh / 2 - cy * K).toFixed(2)}px, 0) scale(${K})`;
    };
    const tick = () => {
      const e = dragging ? 0.5 : 0.12;
      x += (tx - x) * e; y += (ty - y) * e;
      draw();
      if (Math.abs(tx - x) > 0.2 || Math.abs(ty - y) > 0.2) raf = requestAnimationFrame(tick); else { x = tx; y = ty; draw(); raf = 0; }
    };
    const go = (p, instant) => { const b = bounds(p.x, p.y); tx = b.x; ty = b.y; if (instant || reduceMotion) { x = tx; y = ty; draw(); return; } if (!raf) raf = requestAnimationFrame(tick); };

    const local = (e) => { const r = stage.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
    lens.addEventListener('pointerdown', (e) => {
      dragging = true; lens.setPointerCapture(e.pointerId); lens.classList.add('is-dragging', 'has-moved');
      const p = local(e); grab = { x: p.x - x, y: p.y - y };
    });
    lens.addEventListener('pointermove', (e) => { if (!dragging) return; const p = local(e); go({ x: p.x - grab.x, y: p.y - grab.y }); });
    const end = () => { dragging = false; lens.classList.remove('is-dragging'); };
    lens.addEventListener('pointerup', end); lens.addEventListener('pointercancel', end);
    if (fine) {
      chart.addEventListener('pointermove', (e) => { if (dragging) return; hovering = true; lens.classList.add('has-moved'); go(local(e)); });
      stage.addEventListener('pointerleave', () => { if (dragging) return; hovering = false; go(rest()); });
    }
    lens.addEventListener('keydown', (e) => {
      const step = e.shiftKey ? 40 : 12; const m = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] }[e.key];
      if (m) { e.preventDefault(); lens.classList.add('has-moved'); go({ x: tx + m[0], y: ty + m[1] }); }
    });

    const ro = new ResizeObserver(() => { measure(); if (!hovering && !dragging) go(rest(), true); else draw(); });
    const start = () => {
      measure();
      const r = rest();
      x = reduceMotion ? r.x : W + lw * 0.2; y = r.y; tx = x; ty = y; draw();
      lens.classList.add('is-ready'); caustic && caustic.classList.add('is-ready');
      requestAnimationFrame(() => { root.classList.add('is-focused'); setTimeout(() => go(r), reduceMotion ? 0 : 260); });
      ro.observe(stage);
    };
    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(start);
  }

  /* ---------- live 3D (loaded on demand, photos or flat diagram stay as the fallback) ---------- */
  const canGL = (() => { try { const c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl'))); } catch (e) { return false; } })();
  function mount3D(root, kind, onReady) {
    const host = $('[data-gl]', root);
    if (!host || !canGL || !host.dataset.glSrc) return null;
    const ctl = { api: null, p: 0 };
    const go = () => import(new URL(host.dataset.glSrc, document.baseURI).href).then((m) => {
      ctl.api = m.mount(host, { kind, reduceMotion });
      ctl.api.setProgress(ctl.p);
      requestAnimationFrame(() => root.classList.add('is-3d'));
      if (onReady) onReady(ctl.api);
    }).catch((e) => { console.warn('VUERRA 3D unavailable', e); });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); go(); } }, { rootMargin: '120% 0px' });
      io.observe(root);
    } else go();
    root.addEventListener('pointermove', (e) => { if (ctl.api && e.pointerType === 'mouse') ctl.api.setPointer((e.clientX / window.innerWidth) * 2 - 1, (e.clientY / window.innerHeight) * 2 - 1); }, { passive: true });
    root.addEventListener('pointerleave', () => { if (ctl.api) ctl.api.setPointer(0, 0); });
    return ctl;
  }

  /* ---------- exploded view, driven by scroll ---------- */
  function initExploded(root) {
    const track = $('[data-xv-track]', root), stack = $('[data-xv-stack]', root), scene = $('[data-xv-scene]', root);
    if (!track || !stack) return;
    const steps = $$('[data-xv-step]', root);
    const anchors = $$('[data-xv-anchor]', root);
    const labels = $$('[data-xv-label]', root);
    const svg = $('[data-xv-lines]', root);
    const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    let ticking = false, p = 0, idx = 0, labelW = 0, visible = false, loop = 0;
    const gl = mount3D(root, 'layers', () => { layout(); req(); });
    const wide = () => window.innerWidth >= 960 && scene.clientWidth >= 560;
    const layout = () => {
      // reserve a column for the labels so they never sit on top of the diagram
      labelW = wide() ? Math.min(230, Math.round(scene.clientWidth * 0.34)) : 0;
      labels.forEach((l) => { l.style.width = labelW ? labelW + 'px' : ''; });
      if (gl && gl.api) gl.api.setLabelSpace(labelW ? labelW + 36 : 0);
    };
    const drawLabels = (sep) => {
      if (!svg) return;
      if (!labelW) { svg.innerHTML = ''; labels.forEach((l) => l.classList.remove('is-on')); return; }
      const sr = scene.getBoundingClientRect();
      let pts;
      if (gl && gl.api) {
        pts = gl.api.anchors().map((a, i) => ({ i, x: a.x, y: a.y }));
      } else {
        pts = anchors.map((a, i) => { const ar = a.getBoundingClientRect(); return { i, x: ar.left + ar.width / 2 - sr.left, y: ar.top + ar.height / 2 - sr.top }; });
      }
      pts.sort((a, b) => a.y - b.y);
      let paths = '', lastY = -999;
      const lx = sr.width - labelW;
      pts.forEach((pt) => {
        const label = labels[pt.i]; if (!label) return;
        const on = sep > 0.3 + pt.i * 0.1;
        label.classList.toggle('is-on', on);
        label.classList.toggle('is-active', on && pt.i === idx);
        const ly = Math.max(pt.y, lastY + 76); lastY = ly;
        label.style.top = ly + 'px'; label.style.left = lx + 'px'; label.style.right = 'auto';
        if (on) paths += `<path d="M${pt.x.toFixed(1)} ${pt.y.toFixed(1)} C${(pt.x + 40).toFixed(1)} ${pt.y.toFixed(1)} ${(lx - 50).toFixed(1)} ${ly.toFixed(1)} ${(lx - 12).toFixed(1)} ${ly.toFixed(1)}" fill="none" stroke="currentColor" stroke-width="1" opacity="${pt.i === idx ? '.75' : '.35'}"/><circle cx="${pt.x.toFixed(1)}" cy="${pt.y.toFixed(1)}" r="2.6" fill="currentColor" opacity=".9"/>`;
      });
      svg.innerHTML = paths;
    };
    const update = () => {
      ticking = false;
      const r = track.getBoundingClientRect();
      const total = Math.max(1, r.height - window.innerHeight);
      p = clamp(-r.top / total, 0, 1);
      const sep = reduceMotion ? 0.9 : ease(clamp((p - 0.06) / 0.62, 0, 1));
      stack.style.setProperty('--p', sep.toFixed(4));
      idx = p < 0.33 ? 0 : p < 0.62 ? 1 : 2;
      steps.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      if (gl) { gl.p = p; if (gl.api) { gl.api.setProgress(p); gl.api.setActive(idx); } }
      if (!(gl && gl.api)) drawLabels(sep);
    };
    const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    // the 3D layers drift gently, so the leader lines follow them every frame while on screen
    const follow = () => { if (gl && gl.api) drawLabels(reduceMotion ? 0.9 : ease(clamp((p - 0.06) / 0.62, 0, 1))); loop = visible ? requestAnimationFrame(follow) : 0; };
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible && !loop) loop = requestAnimationFrame(follow); }).observe(root);
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', () => { layout(); req(); });
    layout(); update();
  }

  /* ---------- the material up close: chains, platinum, network, driven by scroll ---------- */
  function initMaterial(root) {
    const track = $('[data-mv-track]', root);
    if (!track) return;
    const steps = $$('[data-mv-step]', root);
    const tag = $('[data-mv-pt]', root), bar = $('[data-mv-bar]', root), label = $('[data-mv-scale-label]', root);
    const panel = $('[data-mv-panel]', root), sticky = $('.mv__sticky', root);
    const TH = [0.31, 0.69, 1];
    let p = 0, idx = -1, ticking = false, visible = false, loop = 0, placed = false;
    // keep the scene centred in the space the glass panel leaves free: beside it on wide screens, above it on phones
    const layout = () => {
      if (!(gl && gl.api) || !panel || !sticky) return;
      const sr = sticky.getBoundingClientRect(), pr = panel.getBoundingClientRect();
      if (window.innerWidth >= 960) gl.api.setShift(Math.round((pr.right - sr.left) / 2), 0, !placed);
      else {
        const head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 64;
        const free = Math.max(0, pr.top - sr.top);
        gl.api.setShift(0, Math.round(sr.height / 2 - (head + free) / 2), !placed);
      }
      placed = true;
    };
    const gl = mount3D(root, 'molecule', () => { layout(); req(); });
    const hud = () => {
      if (!(gl && gl.api)) return;
      const a = gl.api.anchors()[0];
      if (tag) {
        const on = !!(a && a.on) && p < 0.86;
        tag.classList.toggle('is-on', on);
        if (a && on) { tag.style.transform = `translate3d(${a.x.toFixed(1)}px, ${a.y.toFixed(1)}px, 0)`; tag.style.setProperty('--r', Math.max(8, Math.min(60, a.r || 20)).toFixed(1) + 'px'); }
      }
      const s = gl.api.scaleBar();
      if (s && bar) { bar.style.width = s.px.toFixed(1) + 'px'; if (label && label.textContent !== s.label) label.textContent = s.label; }
    };
    const update = () => {
      ticking = false;
      const r = track.getBoundingClientRect();
      const total = Math.max(1, r.height - window.innerHeight);
      p = clamp(-r.top / total, 0, 1);
      const i = p < TH[0] ? 0 : p < TH[1] ? 1 : 2;
      if (i !== idx) { idx = i; steps.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.classList.toggle('is-done', k < i); }); if (placed) layout(); }
      steps.forEach((s, k) => { const a = k ? TH[k - 1] : 0; s.style.setProperty('--sp', clamp((p - a) / (TH[k] - a), 0, 1).toFixed(3)); });
      root.classList.toggle('is-lens', p > 0.84);
      if (gl) { gl.p = p; if (gl.api) gl.api.setProgress(p); }
    };
    const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    // the platinum label and the scale bar follow the scene every frame while it is on screen
    const follow = () => { hud(); loop = visible ? requestAnimationFrame(follow) : 0; };
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible && !loop) loop = requestAnimationFrame(follow); }).observe(root);
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', () => { layout(); req(); });
    update();
  }

  /* ---------- light lab ---------- */
  function initLab(root) {
    const svg = $('[data-lab-svg]', root); if (!svg) return;
    const range = $('[data-lab-range]', root), out = $('[data-lab-power]', root), say = $('[data-lab-say]', root), note = $('[data-lab-note]', root);
    const modeBtns = $$('[data-lab-mode]', root);
    const raysG = $('[data-lab-rays]', svg), lensP = $('[data-lab-lens]', svg), focus = $('[data-lab-focus]', svg), guide = $('[data-lab-guide]', svg), ticks = $$('[data-tick]', svg);
    const AX = 170, LX = 230, S = 5, X0 = 20, X1 = 820;
    const offs = [-96, -64, -32, 0, 32, 64, 96];
    let mode = 'plus';
    const sayPlus = (cm) => cm >= 90 ? `Sharpest at about ${cm} cm. A screen across the desk or a menu at arm's length.`
      : cm >= 60 ? `Sharpest at about ${cm} cm. A laptop, a dashboard or a computer screen.`
      : cm >= 45 ? `Sharpest at about ${cm} cm. A tablet, a map or a laptop held close.`
      : cm >= 37 ? `Sharpest at about ${cm} cm. A phone or a paperback held comfortably.`
      : `Sharpest at about ${cm} cm. Fine print, stitching, fishing knots.`;
    const draw = () => {
      const a = Number(range.value);
      const P = mode === 'plus' ? a : -a;
      const f = 100 / a; const cm = Math.round(f);
      out.innerHTML = `${fmtPower(P)}<small>D</small>`;
      range.style.setProperty('--fill', ((a - Number(range.min)) / (Number(range.max) - Number(range.min))) * 100 + '%');
      range.setAttribute('aria-valuetext', `${fmtPower(P)} dioptres`);
      const t = 6 + a * 5;
      if (mode === 'plus') {
        const c = 2 * (6 + a * 6);
        lensP.setAttribute('d', `M${LX} 52 Q${LX + c} ${AX} ${LX} 288 Q${LX - c} ${AX} ${LX} 52 Z`);
      } else {
        const d = 2 * (a * 5);
        lensP.setAttribute('d', `M${LX - t} 52 L${LX + t} 52 Q${LX + t - d} ${AX} ${LX + t} 288 L${LX - t} 288 Q${LX - t + d} ${AX} ${LX - t} 52 Z`);
      }
      let html = '';
      offs.forEach((o) => {
        const y0 = AX + o; const op = 1 - Math.abs(o) / 140;
        html += `<path d="M${X0} ${y0} L${LX} ${y0}" class="ray-in" opacity="${op.toFixed(2)}"/>`;
        if (mode === 'plus') {
          const fx = LX + f * S; const k = (X1 - LX) / (fx - LX);
          const ex = X1, ey = y0 + (AX - y0) * k;
          html += `<path d="M${LX} ${y0} L${ex.toFixed(1)} ${ey.toFixed(1)}" class="ray-out" opacity="${op.toFixed(2)}"/>`;
        } else {
          const vx = LX - f * S; const slope = (y0 - AX) / (LX - vx);
          const ey = y0 + slope * (X1 - LX);
          html += `<path d="M${LX} ${y0} L${X1} ${ey.toFixed(1)}" class="ray-out" opacity="${op.toFixed(2)}"/>`;
          const bx = Math.max(vx, X0); const by = AX + slope * (bx - vx);
          html += `<path d="M${LX} ${y0} L${bx.toFixed(1)} ${by.toFixed(1)}" class="ray-virtual" opacity="${(op * 0.7).toFixed(2)}"/>`;
        }
      });
      raysG.innerHTML = html;
      if (mode === 'plus') {
        const fx = LX + f * S;
        focus.setAttribute('transform', `translate(${fx.toFixed(1)} ${AX})`); focus.style.opacity = 1;
        guide.setAttribute('d', `M${fx.toFixed(1)} ${AX + 12} L${fx.toFixed(1)} 314`); guide.style.opacity = 1;
        let best = null; ticks.forEach((tk) => { const d = Math.abs(Number(tk.dataset.tick) - f); if (!best || d < best.d) best = { d, tk }; });
        ticks.forEach((tk) => tk.classList.toggle('is-near', tk === best.tk));
        say.textContent = sayPlus(cm);
        if (note) note.textContent = note.dataset.plus || '';
      } else {
        focus.style.opacity = 0; guide.style.opacity = 0; ticks.forEach((tk) => tk.classList.remove('is-near'));
        say.textContent = `Helps eyes that see clearly only up to about ${cm} cm bring far things into focus.`;
        if (note) note.textContent = note.dataset.minus || '';
      }
    };
    range.addEventListener('input', draw);
    modeBtns.forEach((b) => b.addEventListener('click', () => {
      mode = b.dataset.labMode; modeBtns.forEach((x) => x.setAttribute('aria-pressed', String(x === b))); draw();
    }));
    draw();
  }

  /* ---------- where it goes (tabs) ---------- */
  function initTabs(root) {
    const tabs = $$('[role="tab"]', root), panels = $$('[role="tabpanel"]', root);
    const select = (t) => {
      tabs.forEach((x) => { const on = x === t; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; });
      panels.forEach((p) => { const on = p.id === t.getAttribute('aria-controls'); p.classList.toggle('is-active', on); p.hidden = false; p.setAttribute('aria-hidden', String(!on)); });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        const d = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
        if (d) { e.preventDefault(); const n = tabs[(i + d + tabs.length) % tabs.length]; n.focus(); select(n); }
      });
    });
  }

  /* ---------- power guide ---------- */
  const AGES = {
    'under-40': { power: null, range: '', note: 'Most people do not need reading power before 40. If small print has started to blur, an eye exam is the right first step.' },
    '40-44': { power: 1.0, range: '+0.75 to +1.25' },
    '45-49': { power: 1.5, range: '+1.25 to +1.75' },
    '50-54': { power: 2.0, range: '+1.75 to +2.25' },
    '55-59': { power: 2.25, range: '+2.00 to +2.50' },
    '60-plus': { power: 2.5, range: '+2.25 to +3.00' }
  };
  /* ---------- try-a-lens magnifier over the sample text ---------- */
  function initMag(el) {
    const lens = $('.mag__lens', el), copy = $('[data-mag-copy]', el), tag = $('[data-mag-tag]', el);
    if (!lens || !copy) return;
    let s = 1.5;
    el.__setPower = (pw) => { s = 1 + Math.max(0.5, pw) / 4; if (tag) tag.textContent = fmtPower(pw); };
    const place = (cx, cy) => {
      const r = el.getBoundingClientRect();
      const x = clamp(cx - r.left, 0, r.width), y = clamp(cy - r.top, 0, r.height);
      const lw = lens.offsetWidth, lh = lens.offsetHeight;
      copy.style.width = r.width + 'px';
      el.style.setProperty('--lx', (x - lw / 2) + 'px'); el.style.setProperty('--ly', (y - lh * 0.42) + 'px');
      lens.style.setProperty('--lx', (x - lw / 2) + 'px'); lens.style.setProperty('--ly', (y - lh * 0.42) + 'px');
      copy.style.transform = `translate(${(lw / 2 - x * s).toFixed(1)}px, ${(lh * 0.42 - y * s).toFixed(1)}px) scale(${s})`;
    };
    el.addEventListener('pointerenter', (e) => { el.classList.add('is-on'); place(e.clientX, e.clientY); });
    el.addEventListener('pointermove', (e) => { el.classList.add('is-on'); place(e.clientX, e.clientY); });
    el.addEventListener('pointerleave', () => el.classList.remove('is-on'));
    el.addEventListener('pointerdown', (e) => { el.classList.add('is-on'); place(e.clientX, e.clientY); });
    el.addEventListener('pointerup', (e) => { if (e.pointerType !== 'mouse') setTimeout(() => el.classList.remove('is-on'), 1400); });
  }

  function initGuide(root) {
    const res = $('[data-guide-result]', root); if (!res) return;
    const powerEl = $('[data-guide-power]', root), rangeEl = $('[data-guide-range]', root), noteEl = $('[data-guide-note]', root), cta = $('[data-guide-cta]', root);
    const productEl = $('[data-guide-product]', root);
    const product = productEl ? JSON.parse(productEl.textContent) : null;
    const powerName = (A.powerOption || 'Power').toLowerCase();
    const findVariant = (label) => {
      if (!product) return null;
      const idx = product.options.findIndex((o) => String(o.name || o).toLowerCase() === powerName);
      if (idx < 0) return null;
      const norm = (s) => String(s).replace(MINUS, '-').replace(/\s/g, '');
      return product.variants.find((v) => norm(v.options[idx]) === norm(label) && v.available !== false) || product.variants.find((v) => norm(v.options[idx]) === norm(label));
    };
    root.addEventListener('change', (e) => {
      if (!e.target.matches('[name^="age"]')) return;
      const d = AGES[e.target.value]; res.hidden = false;
      if (!d.power) {
        powerEl.textContent = 'Not yet'; rangeEl.textContent = ''; noteEl.textContent = d.note; cta.hidden = true; return;
      }
      const label = fmtPower(d.power).replace(MINUS, '-');
      powerEl.textContent = fmtPower(d.power);
      $$('[data-mag]', root).forEach((m) => m.__setPower && m.__setPower(d.power));
      rangeEl.textContent = `Most people your age land between ${d.range}.`;
      noteEl.textContent = 'Already own readers that work? Choose the same power.';
      cta.hidden = false;
      cta.dataset.power = label;
      const pdpForm = $('[data-product-form-root]');
      if (root.closest('.drawer') && pdpForm) { cta.textContent = `Use ${fmtPower(d.power)}`; return; }
      const v = findVariant(label);
      if (v && product) { cta.href = `${product.url}?variant=${v.id}`; }
      cta.textContent = `Shop ${fmtPower(d.power)}`;
    });
    cta && cta.addEventListener('click', (e) => {
      const pdp = $('[data-product-form-root]');
      if (root.closest('.drawer') && pdp && pdp.__form) {
        e.preventDefault(); pdp.__form.selectPower(cta.dataset.power); Drawer.close(root.closest('.drawer'));
      }
    });
  }

  /* ---------- product form ---------- */
  class ProductForm {
    constructor(root) {
      this.root = root; root.__form = this;
      this.form = $('form[data-product-form]', root);
      this.product = JSON.parse($('[data-product-json]', root).textContent);
      this.idInput = $('input[name="id"]', this.form);
      this.btn = $('[data-atc]', this.form);
      this.error = $('[data-buy-error]', root);
      this.packName = (root.dataset.packOption || 'pack').toLowerCase();
      this.powerName = (root.dataset.powerOption || 'power').toLowerCase();
      this.optNames = this.product.options.map((o) => String(o.name || o).toLowerCase());
      this.packIdx = this.optNames.indexOf(this.packName);
      this.powerIdx = this.optNames.indexOf(this.powerName);
      this.form.addEventListener('change', () => this.update());
      if (A.cartType !== 'page') this.form.addEventListener('submit', (e) => this.submit(e));
      const want = new URLSearchParams(location.search).get('variant');
      const pre = want && this.product.variants.find((v) => String(v.id) === want);
      if (pre && A.preview) pre.options.forEach((val, i) => { const inp = $$(`[data-option-index="${i}"]`, this.form).find((x) => x.value === val); if (inp) inp.checked = true; });
      this.update(true);
    }
    selected() {
      return this.product.options.map((_, i) => {
        const c = $(`[data-option-index="${i}"]:checked`, this.form) || $(`select[data-option-index="${i}"]`, this.form);
        return c ? c.value : null;
      });
    }
    variantFor(sel) { return this.product.variants.find((v) => v.options.every((o, i) => sel[i] == null || o === sel[i])); }
    plan() { const r = $('input[name="selling_plan"]:checked', this.form); return r && r.value ? r.value : null; }
    priceFor(v, plan) {
      if (!plan || !v) return v ? v.price : 0;
      const a = (v.selling_plan_allocations || []).find((x) => String(x.selling_plan_id) === String(plan));
      return a ? a.price : v.price;
    }
    selectPower(label) {
      if (this.powerIdx < 0) return;
      const norm = (s) => String(s).replace(MINUS, '-').replace(/\s/g, '');
      const input = $$(`[data-option-index="${this.powerIdx}"]`, this.form).find((i) => norm(i.value) === norm(label));
      if (input) { input.checked = true; this.update(); input.closest('.power') && input.focus({ preventScroll: true }); }
    }
    update(initial) {
      const sel = this.selected();
      const v = this.variantFor(sel);
      const plan = this.plan();
      sel.forEach((val, i) => { if (val != null) $$(`[data-option-value="${i}"]`, this.root).forEach((el) => { el.textContent = val; }); });
      if (!v) {
        this.btn.disabled = true; $('[data-atc-label]', this.btn).textContent = A.strings.unavailable; return;
      }
      const needPower = this.powerIdx > -1 && sel[this.powerIdx] == null;
      this.current = v;
      this.idInput.value = v.id;
      if (!initial && !A.preview) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      const price = this.priceFor(v, plan);
      $$('[data-price]', this.root).forEach((el) => { el.textContent = money(price); });
      const ref = plan ? v.price : (v.compare_at_price > v.price ? v.compare_at_price : null);
      $$('[data-compare]', this.root).forEach((el) => { el.textContent = ref ? money(ref) : ''; el.hidden = !ref; });
      $$('[data-save]', this.root).forEach((el) => { el.textContent = ref ? `Save ${Math.round((1 - price / ref) * 100)}%` : ''; el.hidden = !ref; });
      this.btn.disabled = !v.available || needPower;
      $('[data-atc-label]', this.btn).textContent = needPower ? (A.strings.choosePower || 'Choose your power') : v.available ? A.strings.addToBag : A.strings.soldOut;
      this.root.classList.toggle('needs-power', needPower);
      $$('[data-atc-price]', this.root).forEach((el) => { el.textContent = v.available ? money(price) : ''; });
      // tiers
      if (this.packIdx > -1) {
        const values = this.product.options[this.packIdx].values || [...new Set(this.product.variants.map((x) => x.options[this.packIdx]))];
        const pairs = (s) => parseInt(String(s), 10) || 1;
        const tierVariant = (val) => this.variantFor(sel.map((s, i) => (i === this.packIdx ? val : s)));
        const single = tierVariant(values[0]);
        const singleUnit = single ? this.priceFor(single, plan) / pairs(values[0]) : 0;
        $$('[data-tier]', this.root).forEach((t) => {
          const tv = tierVariant(t.dataset.tier); if (!tv) return;
          const n = pairs(t.dataset.tier); const p = this.priceFor(tv, plan);
          $('[data-tier-price]', t).textContent = money(p);
          const full = singleUnit * n;
          const per = $('[data-tier-per]', t);
          if (per) per.textContent = n > 1 ? `${money(Math.round(p / n))} per pair${full - p > 50 ? `. Save ${money(Math.round(full - p))}` : ''}` : 'One pair';
          t.classList.toggle('is-unavailable', !tv.available);
        });
      }
      // plans
      $$('[data-plan-price]', this.root).forEach((el) => { el.textContent = money(this.priceFor(v, el.dataset.planPrice || null)); });
      $$('[data-plan-then]', this.root).forEach((el) => {
        const a = (v.selling_plan_allocations || []).find((x) => String(x.selling_plan_id) === String(el.dataset.planThen));
        const adj = a && a.price_adjustments && a.price_adjustments.length > 1 ? a.price_adjustments[a.price_adjustments.length - 1] : null;
        if (adj) el.textContent = money(adj.price);
      });
      // availability of powers
      if (this.powerIdx > -1) {
        $$(`[data-option-index="${this.powerIdx}"]`, this.form).forEach((inp) => {
          const tv = this.variantFor(sel.map((s, i) => (i === this.powerIdx ? inp.value : s)));
          inp.closest('.power') && inp.closest('.power').classList.toggle('is-unavailable', !tv || !tv.available);
        });
      }
      // sticky
      $$('[data-sticky-variant]').forEach((el) => { el.textContent = needPower ? (this.packIdx > -1 ? sel[this.packIdx] : '') : v.title === 'Default Title' ? '' : v.title; });
      // media
      if (!initial && v.featured_media && A.gallery) A.gallery.goToMedia(v.featured_media.id);
      document.dispatchEvent(new CustomEvent('vuerra:variant', { detail: { variant: v } }));
    }
    async submit(e) {
      e.preventDefault();
      if (this.root.classList.contains('needs-power')) { const f = $(`[data-option-index="${this.powerIdx}"]`, this.form); f && f.focus(); return; }
      if (!this.current || !this.current.available) return;
      this.btn.classList.add('is-loading'); this.btn.disabled = true;
      if (this.error) this.error.hidden = true;
      try {
        await Cart.addForm(new FormData(this.form));
        await CartUI.loadUpsell();
        await Cart.fetch();
        Drawer.open('CartDrawer');
      } catch (err) {
        if (this.error) { this.error.textContent = err.message; this.error.hidden = false; }
      } finally {
        this.btn.classList.remove('is-loading'); this.btn.disabled = false;
      }
    }
  }

  /* ---------- gallery ---------- */
  function initGallery(root) {
    const main = $('[data-gallery-main]', root); if (!main) return;
    const slides = $$('[data-media-id]', main), thumbs = $$('[data-thumb]', root), dots = $$('[data-dot]', root);
    const set = (i) => {
      thumbs.forEach((t, j) => t.setAttribute('aria-current', String(i === j)));
      dots.forEach((d, j) => d.classList.toggle('is-on', i === j));
    };
    const go = (i) => { main.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); set(i); };
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    let tm;
    main.addEventListener('scroll', () => { clearTimeout(tm); tm = setTimeout(() => set(Math.round(main.scrollLeft / main.clientWidth)), 60); }, { passive: true });
    A.gallery = { goToMedia: (id) => { const i = slides.findIndex((s) => String(s.dataset.mediaId) === String(id)); if (i > -1) go(i); } };
  }

  /* ---------- sticky add to bag ---------- */
  function initSticky(root) {
    const bar = $('[data-sticky-buy]'); const target = $('[data-atc]', root);
    if (!bar || !target) return;
    const io = new IntersectionObserver(([e]) => { bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); }, { threshold: 0 });
    io.observe(target);
    $('[data-sticky-add]', bar).addEventListener('click', () => {
      if (root.classList.contains('needs-power')) { const p = $('.powers', root); p && p.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' }); return; }
      const f = $('form[data-product-form]', root); if (f.requestSubmit) f.requestSubmit(); else target.click();
    });
    const sync = (v) => { const b = $('[data-sticky-add]', bar); b.disabled = v ? !v.available : false; b.textContent = root.classList.contains('needs-power') ? 'Choose your power' : 'Add to bag'; };
    document.addEventListener('vuerra:variant', (e) => sync(e.detail.variant));
    sync(root.__form && root.__form.current);
  }

  /* ---------- simple forms in preview ---------- */
  if (Preview) {
    // The artifact viewer carries the last page's scroll position into the next page it opens,
    // so a link clicked near the bottom of one page landed near the bottom of the next.
    // Open every fresh page at the top, and undo any scroll that arrives before the visitor touches anything.
    (() => {
      const nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
      if (location.hash || nav.type === 'back_forward') return;
      let touched = false;
      let until = performance.now() + 2500;
      // also count frames after load: on a slow device a heavy page can hold the main thread past the time window,
      // and a carried-over scroll that is handled late must still be undone
      let frames = 0;
      const mark = () => { touched = true; };
      ['wheel', 'touchstart', 'keydown', 'pointerdown', 'mousedown'].forEach((t) => window.addEventListener(t, mark, { passive: true, capture: true }));
      const toTop = () => {
        if (touched) return;
        if ((window.scrollY || document.documentElement.scrollTop) > 0) window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      };
      const active = () => !touched && (performance.now() < until || frames < 24);
      const onScroll = () => { if (!active()) { window.removeEventListener('scroll', onScroll); return; } toTop(); };
      const tick = () => { frames++; if (active()) { toTop(); requestAnimationFrame(tick); } };
      toTop();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('pageshow', toTop);
      window.addEventListener('load', () => { until = Math.max(until, performance.now() + 1500); toTop(); requestAnimationFrame(tick); });
    })();
    document.addEventListener('submit', (e) => {
      const f = e.target; if (f.matches('form[data-product-form]')) return;
      e.preventDefault();
      const msg = f.querySelector('[data-form-msg]') || f.parentElement.querySelector('[data-form-msg]');
      if (msg) { msg.hidden = false; msg.textContent = f.dataset.success || 'Thanks. You are on the list.'; msg.className = 'form-msg form-msg--ok'; }
      f.reset();
    });
    document.addEventListener('click', (e) => {
      if (e.defaultPrevented) return;
      const a = e.target.closest('a[href]');
      if (!a) return;
      const href = a.getAttribute('href');
      if (href && href.startsWith('/') && !a.hasAttribute('data-preview-ok')) {
        const map = (A.previewRoutes || {});
        const path = href.split(/[?#]/)[0];
        const hit = map[path] || (path.startsWith('/products/') ? map['/products/*'] : null) || (path.startsWith('/collections/') ? map['/collections/*'] : null);
        e.preventDefault();
        const rest = href.slice(path.length);
        if (hit) location.href = hit + rest;
      }
    });
  }

  /* ---------- image sequences (hero autoplay, scroll scrub) ---------- */
  function initSeq(root) {
    const canvas = $('canvas', root); if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const n = Number(root.dataset.frames) || 0; const tpl = root.dataset.tpl || '';
    if (!n || !tpl) return;
    const mode = root.dataset.mode || 'scroll';
    const focus = (Number(root.dataset.focus) || 50) / 100;
    const poster = $('[data-seq-poster]', root);
    const frames = new Array(n);
    const url = (i) => tpl.replace('__N__', String(i).padStart(3, '0'));
    let cur = 0, shown = -1, started = false;
    const fit = () => {
      const r = canvas.getBoundingClientRect(); const dpr = Math.min(2, window.devicePixelRatio || 1);
      const w = Math.max(1, Math.round(r.width * dpr)), h = Math.max(1, Math.round(r.height * dpr));
      if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; shown = -1; draw(cur); }
    };
    const nearest = (i) => {
      for (let d = 0; d < n; d++) {
        const a = frames[i - d], b = frames[i + d];
        if (a && a.__ok) return a; if (b && b.__ok) return b;
      }
      return null;
    };
    function draw(i) {
      i = Math.max(0, Math.min(n - 1, Math.round(i)));
      const img = nearest(i); if (!img) return;
      if (img === shown) return; shown = img;
      const cw = canvas.width, ch = canvas.height, iw = img.naturalWidth, ih = img.naturalHeight;
      const s = Math.max(cw / iw, ch / ih); const dw = iw * s, dh = ih * s;
      const dx = (cw - dw) * focus, dy = (ch - dh) / 2;
      ctx.clearRect(0, 0, cw, ch); ctx.drawImage(img, dx, dy, dw, dh);
      if (poster && !poster.hidden) poster.hidden = true;
    }
    const load = (i) => new Promise((res) => {
      if (frames[i]) return res();
      const im = new Image(); im.decoding = 'async';
      im.onload = () => { im.__ok = true; res(); if (Math.round(cur) === i || shown === -1) { shown = -1; draw(cur); } };
      im.onerror = () => res();
      im.src = url(i); frames[i] = im;
    });
    const order = () => {
      const o = [0, n - 1]; for (const step of [16, 8, 4, 2, 1]) for (let i = 0; i < n; i += step) if (!o.includes(i)) o.push(i);
      return o;
    };
    const loadAll = async () => { const o = order(); for (let k = 0; k < o.length; k += 6) await Promise.all(o.slice(k, k + 6).map(load)); };
    const ro = new ResizeObserver(fit); ro.observe(canvas);
    if (mode === 'play') {
      const fps = Number(root.dataset.fps) || 30; const replay = $('[data-seq-replay]', root);
      const play = () => {
        root.classList.remove('is-done');
        if (reduceMotion) { cur = n - 1; draw(cur); root.classList.add('is-done'); return; }
        const t0 = performance.now();
        const step = (now) => { cur = Math.min(n - 1, ((now - t0) / 1000) * fps); draw(cur); if (cur < n - 1) requestAnimationFrame(step); else root.classList.add('is-done'); };
        requestAnimationFrame(step);
      };
      const io = new IntersectionObserver(async ([e]) => {
        if (!e.isIntersecting || started) return; started = true; io.disconnect();
        await load(0); fit(); draw(0);
        await loadAll(); setTimeout(play, 250);
      }, { threshold: 0.25 });
      io.observe(root);
      replay && replay.addEventListener('click', play);
      return;
    }
    // scroll mode
    const track = $('[data-seq-track]', root) || root;
    const steps = $$('.seq__step', root), dots = $$('.seq__dots i', root);
    let ticking = false;
    const update = () => {
      ticking = false;
      const r = track.getBoundingClientRect(); const total = Math.max(1, r.height - window.innerHeight);
      const p = clamp(-r.top / total, 0, 1);
      cur = p * (n - 1); draw(cur);
      steps.forEach((st, i) => {
        const a = Number(st.dataset.from) / 100, b = Number(st.dataset.to) / 100;
        const on = p >= a && (p < b || (b >= 1 && p >= a));
        st.classList.toggle('is-active', on);
        const w = clamp((p - a) / Math.max(0.0001, b - a), 0, 1) * 100;
        const bar = $('.bar i', st); if (bar) bar.style.setProperty('--w', w + '%');
        if (dots[i]) dots[i].classList.toggle('is-on', on);
      });
    };
    const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !started) { started = true; load(0).then(() => { fit(); update(); }); loadAll(); }
    }, { rootMargin: '800px 0px' });
    io.observe(root);
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    update();
  }

  /* ---------- before / after slider ---------- */
  function initBA(root) {
    const range = $('[data-ba-range]', root); if (!range) return;
    const set = () => root.style.setProperty('--x', range.value + '%');
    let touched = false;
    range.addEventListener('input', () => { touched = true; set(); });
    range.addEventListener('pointerdown', () => { touched = true; });
    set();
    // one gentle sweep when it first comes into view, to show it can be dragged
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      const keys = [[0, 50], [0.35, 18], [0.75, 82], [1, 50]]; const dur = 2400; let t0 = 0;
      const ease = (k) => (k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2);
      const step = (now) => {
        if (touched) return;
        if (!t0) t0 = now;
        const k = Math.min(1, (now - t0) / dur);
        let v = 50;
        for (let j = 1; j < keys.length; j++) { if (k <= keys[j][0]) { const a = keys[j - 1], b = keys[j]; v = a[1] + (b[1] - a[1]) * ease((k - a[0]) / (b[0] - a[0])); break; } }
        range.value = String(Math.round(v)); set();
        if (k < 1) requestAnimationFrame(step);
      };
      setTimeout(() => requestAnimationFrame(step), 400);
    }, { threshold: 0.6 });
    io.observe(root);
  }

  /* ---------- power finder: up to three questions, one suggested power ---------- */
  const FINDER_AGES = {
    '40-44': [1.0, '+1.00 to +1.25', '40 to 44'],
    '45-49': [1.5, '+1.25 to +1.75', '45 to 49'],
    '50-54': [2.0, '+1.75 to +2.25', '50 to 54'],
    '55-59': [2.25, '+2.00 to +2.50', '55 to 59'],
    '60-plus': [2.5, '+2.25 to +3.00', '60 and over']
  };
  const FINDER_USE = {
    close: [0, 'set for close reading.'],
    screens: [-0.5, 'taken 0.50 lower for screens.'],
    mix: [-0.25, 'taken 0.25 lower for print and screens.']
  };
  function pickVariant(prod, label) {
    if (!prod) return null;
    const lc = (s) => String(s || '').toLowerCase();
    const pi = prod.options.findIndex((o) => lc(o.name || o) === lc(A.powerOption || 'Power'));
    if (pi < 0) return null;
    const ki = prod.options.findIndex((o) => lc(o.name || o) === lc(A.packOption || 'Pack'));
    const norm = (s) => String(s).replace(MINUS, '-').replace(/\s/g, '');
    const packs = ki > -1 ? [...new Set(prod.variants.map((v) => v.options[ki]))] : [];
    const want = packs.length ? packs[Math.min(1, packs.length - 1)] : null;
    const ok = (v) => norm(v.options[pi]) === norm(label);
    return prod.variants.find((v) => ok(v) && (!want || v.options[ki] === want) && v.available !== false)
      || prod.variants.find((v) => ok(v) && v.available !== false) || prod.variants.find(ok) || null;
  }
  function initFinder(root) {
    const qs = $$('[data-pf-q]', root);
    const back = $('[data-pf-back]', root), count = $('[data-pf-count]', root), bar = $('[data-pf-bar]', root);
    const card = $('[data-pf-card]', root);
    const powerEl = $('[data-pf-power]', root), whyEl = $('[data-pf-why]', root);
    const prods = {};
    $$('[data-pf-product]', root).forEach((s) => { try { prods[s.dataset.pfProduct] = JSON.parse(s.textContent); } catch (e) { /* ignore */ } });
    const state = {}; const hist = [];
    let started = false, counter = 0;
    const total = () => (state.readers === 'yes' ? 2 : 3);
    const STEP = { readers: 1, own: 2, age: 2, use: 3 };
    const show = (name, push = true) => {
      const cur = qs.find((q) => !q.hidden);
      if (push && cur && cur.dataset.pfQ !== name) hist.push(cur.dataset.pfQ);
      qs.forEach((q) => { q.hidden = q.dataset.pfQ !== name; });
      const done = !STEP[name];
      const n = STEP[name] || total();
      count.textContent = done ? 'Your result' : `Question ${n} of ${total()}`;
      bar.style.setProperty('--w', (done ? 100 : ((n - 0.5) / total()) * 100).toFixed(1) + '%');
      root.classList.toggle('is-done', done);
      back.hidden = !hist.length;
      if (started) {
        const target = qs.find((q) => q.dataset.pfQ === name);
        const f = target && $('[tabindex="-1"]', target);
        if (f) f.focus({ preventScroll: true });
        const r = card.getBoundingClientRect();
        const head = (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 72) + 12;
        if (r.top < head) window.scrollBy({ top: r.top - head, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      started = true;
    };
    const fmt = (n) => '+' + n.toFixed(2);
    const spin = (to) => {
      const id = ++counter;
      if (reduceMotion) { powerEl.textContent = fmt(to); return; }
      const from = Math.max(1, to - 1), t0 = performance.now(), dur = 700;
      const step = (now) => {
        if (id !== counter) return;
        const k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        powerEl.textContent = fmt(Math.round((from + (to - from) * e) * 4) / 4);
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const result = () => {
      let p, why;
      if (state.readers === 'yes') {
        p = parseFloat(state.own);
        why = 'The same number as your readers. It works for Half and Full.';
      } else {
        const a = FINDER_AGES[state.age] || FINDER_AGES['50-54'];
        const u = FINDER_USE[state.use] || FINDER_USE.close;
        const raw = a[0] + u[0];
        p = Math.min(3, Math.max(1, Math.round(raw * 4) / 4));
        why = `Typical for ${a[2]}, ${u[1]}`;
        if (raw < 1) why += ' It is our lowest power.';
      }
      spin(p);
      whyEl.textContent = why;
      $$('[data-mag]', root).forEach((m) => m.__setPower && m.__setPower(p));
      $$('[data-pf-cta-power]', root).forEach((el) => { el.textContent = fmt(p); });
      $$('[data-pf-cta]', root).forEach((a) => {
        const prod = prods[a.dataset.pfCta]; const v = pickVariant(prod, fmt(p));
        if (prod && v) a.href = `${prod.url}?variant=${v.id}`;
      });
      show('result');
    };
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-pf-val]'); if (!b || !root.contains(b)) return;
      const q = b.closest('[data-pf-q]').dataset.pfQ;
      $$('[data-pf-val]', b.parentElement).forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      state[q] = b.dataset.pfVal;
      setTimeout(() => {
        if (q === 'readers') show(b.dataset.pfVal === 'yes' ? 'own' : 'age');
        else if (q === 'own') result();
        else if (q === 'age') show(b.dataset.pfVal === 'under-40' ? 'young' : 'use');
        else if (q === 'use') result();
      }, reduceMotion ? 0 : 240);
    });
    back.addEventListener('click', () => { const prev = hist.pop(); if (prev) show(prev, false); });
    $$('[data-pf-restart]', root).forEach((b) => b.addEventListener('click', () => {
      hist.length = 0; Object.keys(state).forEach((k) => delete state[k]);
      $$('[data-pf-val]', root).forEach((x) => x.removeAttribute('aria-pressed'));
      show('readers', false);
    }));
    show('readers', false);
  }

  /* ---------- FAQ page: live search and topic filter ---------- */
  function initFaq(root) {
    const input = $('[data-faq-q]', root), clear = $('[data-faq-clear]', root), empty = $('[data-faq-empty]', root);
    const groups = $$('[data-faq-group]', root), cats = $$('[data-faq-cat]', root);
    const items = $$('[data-faq-item]', root).map((d) => {
      const q = $('[data-faq-text]', d);
      return { d, q, orig: q.textContent, text: d.textContent.toLowerCase().replace(/\s+/g, ' '), group: d.closest('[data-faq-group]').dataset.faqGroup };
    });
    let cat = 'all';
    const reEsc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const apply = () => {
      const terms = (input.value || '').toLowerCase().trim().split(/\s+/).filter(Boolean);
      let shown = 0;
      items.forEach((it) => {
        const on = (cat === 'all' || it.group === cat) && terms.every((t) => it.text.includes(t));
        it.d.hidden = !on;
        if (on) shown++;
        if (on && terms.length) {
          const re = new RegExp(`(${terms.map(reEsc).join('|')})`, 'gi');
          it.q.innerHTML = esc(it.orig).replace(re, '<mark>$1</mark>');
        } else it.q.textContent = it.orig;
      });
      groups.forEach((g) => { g.hidden = !items.some((it) => it.group === g.dataset.faqGroup && !it.d.hidden); });
      empty.hidden = shown > 0;
      clear.hidden = !input.value;
      root.classList.toggle('is-searching', !!terms.length);
      if (terms.length && shown === 1) items.find((it) => !it.d.hidden).d.open = true;
    };
    input.addEventListener('input', apply);
    input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { input.value = ''; apply(); } });
    clear.addEventListener('click', () => { input.value = ''; apply(); input.focus(); });
    cats.forEach((b) => b.addEventListener('click', () => {
      cat = b.dataset.faqCat;
      cats.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      apply();
    }));
    // open a question linked by its id, e.g. /pages/faq#Q-q-7
    if (location.hash) { const t = document.getElementById(decodeURIComponent(location.hash.slice(1))); if (t && t.matches('[data-faq-item]')) t.open = true; }
  }

  /* ---------- placement guide: Half or Full ---------- */
  function initPlacement(root) {
    const stage = $('[data-pl-stage]', root); const btns = $$('[data-pl-mode]', root); const panels = $$('[data-pl-panel]', root);
    if (!stage) return;
    btns.forEach((b) => b.addEventListener('click', () => {
      const m = b.dataset.plMode;
      stage.dataset.mode = m;
      btns.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      panels.forEach((p) => { p.hidden = p.dataset.plPanel !== m; });
    }));
  }

  /* ---------- boot ---------- */
  /* ---------- v3: premium motion ---------- */
  function splitWords(el) {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    let i = 0;
    const walk = (node) => {
      Array.from(node.childNodes).forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span');
            w.className = 'w'; w.textContent = part; w.style.setProperty('--wi', i++);
            frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && !n.classList.contains('w') && !n.hasAttribute('data-rotate') && !n.classList.contains('visually-hidden')) walk(n);
      });
    };
    walk(el);
  }
  function initReveal() {
    const els = $$('[data-reveal]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach((e) => io.observe(e));
  }
  function initWords() {
    const els = $$('[data-words]');
    els.forEach(splitWords);
    if (!els.length || reduceMotion) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        const p = clamp((vh * 0.9 - r.top) / (vh * 0.36), 0, 1);
        const ws = el.__ws || (el.__ws = $$('.w', el));
        const n = ws.length;
        ws.forEach((w, k) => { const o = clamp(p * (n + 3) - k, 0, 1); w.style.setProperty('--o', (0.16 + o * 0.84).toFixed(3)); });
      });
    };
    const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    update();
  }
  function initCount() {
    $$('[data-count-to]').forEach((el) => {
      const raw = el.dataset.countTo;
      const to = parseFloat(raw);
      const dec = (raw.split('.')[1] || '').length;
      const pre = el.dataset.prefix || '';
      const suf = el.dataset.suffix || '';
      const fmt = (v) => pre + v.toFixed(dec) + suf;
      if (reduceMotion || !('IntersectionObserver' in window)) { el.textContent = fmt(to); return; }
      el.textContent = fmt(0);
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        const t0 = performance.now(); const dur = 1500;
        const step = (now) => { const k = Math.min(1, (now - t0) / dur); el.textContent = fmt(to * (1 - Math.pow(1 - k, 4))); if (k < 1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      }, { threshold: 0.6 });
      io.observe(el);
    });
  }
  function initSpot() {
    $$('.spot').forEach((el) => el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      el.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }));
  }
  function initAmb() {
    $$('.amb').forEach((el) => {
      const img = $('img', el); if (!img) return;
      const set = () => el.style.setProperty('--amb', 'url("' + (img.currentSrc || img.src) + '")');
      if (img.complete && img.naturalWidth) set(); else img.addEventListener('load', set, { once: true });
    });
  }
  /* ---------- hero: swap the first line through every kind of eyewear ---------- */
  function initRotate(el) {
    const words = $$('.rot__word', el);
    if (words.length < 2) return;
    words.forEach((w) => w.classList.remove('is-on'));
    let i = 0, visible = true;
    // the first word arrives with the headline's own blur-in
    setTimeout(() => words[0].classList.add('is-on'), 260);
    const next = () => {
      const cur = words[i]; i = (i + 1) % words.length; const nw = words[i];
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      setTimeout(() => cur.classList.remove('is-out'), 950);
      nw.classList.add('is-on');
    };
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { visible = e.isIntersecting; }).observe(el);
    setInterval(() => { if (visible && !document.hidden) next(); }, reduceMotion ? 3600 : 2600);
  }

  function initDHero(h) {
    if (reduceMotion) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      const r = h.getBoundingClientRect();
      h.style.setProperty('--p', clamp(-r.top / Math.max(1, r.height), 0, 1).toFixed(4));
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
  /* ---------- hero: the box from above opens as you scroll, a lens lifts out, the lights go down into How it works ---------- */
  function initBoxHero(root) {
    const track = $('[data-bhero-track]', root), host = $('[data-gl]', root), head = $('[data-bhero-head]', root), box = $('[data-bhero-box]', root), hint = $('.bhero__hint', root);
    if (!track || !host) return;
    const caps = $$('[data-cap]', root).map((el) => { const [a, b] = el.dataset.cap.split(',').map((x) => parseFloat(x) / 100); return { el, a, b }; });
    const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    let api = null, p = 0, ticking = false, shown = -1;
    const endDark = root.dataset.endDark !== 'false';
    // the box top's place on screen, so the 3D box starts exactly where the picture of it sits
    const boxRect = () => { const r = box.getBoundingClientRect(), s = host.getBoundingClientRect(); return { x: r.left - s.left, y: r.top - s.top, w: r.width, h: r.height }; };
    if (box && !box.complete) box.addEventListener('load', () => { if (api) api.setBox(boxRect()); }, { once: true });
    // words, captions and the dark fade follow the scene's own eased time, so they stay in step with the picture
    const paint = (q) => {
      if (Math.abs(q - shown) < 1e-4) return; shown = q;
      const k = clamp(q / 0.09, 0, 1);
      head.style.opacity = (1 - k).toFixed(3);
      head.style.transform = k ? `translate3d(0, ${(-k * 44).toFixed(1)}px, 0)` : '';
      head.style.visibility = k > 0.99 ? 'hidden' : '';
      caps.forEach(({ el, a, b }) => {
        const f = 0.03, o = Math.min(clamp((q - a) / f, 0, 1), b >= 1 ? 1 : clamp((b - q) / f, 0, 1));
        el.style.opacity = o.toFixed(3); el.style.transform = `translate3d(0, ${((1 - o) * 16).toFixed(1)}px, 0)`;
      });
      if (hint) hint.style.opacity = (1 - clamp(q / 0.03, 0, 1)).toFixed(3);
      root.style.setProperty('--bhero-dk', endDark ? ease(clamp((q - 0.55) / 0.12, 0, 1)).toFixed(3) : '0');
      root.classList.toggle('is-dark', endDark && q > 0.61);
    };
    const update = () => {
      ticking = false;
      const r = track.getBoundingClientRect(), total = Math.max(1, r.height - window.innerHeight);
      p = clamp(-r.top / total, 0, 1);
      if (api) api.setProgress(p); else paint(p);
    };
    const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', () => { req(); if (api) api.setBox(boxRect()); });
    update(); root.heroUpdate = () => { update(); if (api) paint(api.stage.t); };
    if (!canGL || reduceMotion) { root.classList.add('is-static'); return; }
    import(new URL(host.dataset.glSrc, document.baseURI).href).then((m) => {
      const pageBg = getComputedStyle(document.body).backgroundColor || '#ffffff';   // the stage edges match the page, so the canvas melts in
      api = m.mount(host, { kind: 'hero', reduceMotion, variant: host.dataset.glVariant || 'half', endDark, bg: pageBg, mid: pageBg, artBase: new URL(host.dataset.glArt || 'assets/', document.baseURI).href });
      root.heroApi = api;
      api.stage.onFrame = paint;
      api.setBox(boxRect()); api.setProgress(p);
      return api.ready;
    }).then(() => { requestAnimationFrame(() => root.classList.add('is-3d')); })
      .catch((e) => { console.warn('VUERRA 3D unavailable', e); api = null; root.classList.add('is-static'); paint(p); });
    root.addEventListener('pointermove', (e) => { if (api && e.pointerType === 'mouse') api.setPointer((e.clientX / window.innerWidth) * 2 - 1, (e.clientY / window.innerHeight) * 2 - 1); }, { passive: true });
  }
  /* ---------- the simple hero: the picture rises and settles as you scroll ---------- */
  function initAHero(h) {
    if (reduceMotion) return;
    let ticking = false;
    const update = () => { ticking = false; const r = h.getBoundingClientRect(); h.style.setProperty('--ap', clamp(-r.top / Math.max(1, r.height * 0.7), 0, 1).toFixed(4)); };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
  function initHowPhotos(root) {
    const track = $('[data-hp-track]', root);
    const frames = $$('.hp__frame', root);
    const steps = $$('.seq__step', root);
    const dots = $$('.seq__dots i', root);
    const num = $('[data-hp-num]', root);
    const n = frames.length;
    if (!n || !track) return;
    let ticking = false; let cur = -1;
    const gl = mount3D(root, 'how', () => { cur = -1; req(); });
    const marks = () => (gl && gl.api && gl.api.steps && gl.api.steps.length === n ? gl.api.steps : null);
    const update = () => {
      ticking = false;
      const r = track.getBoundingClientRect();
      const total = Math.max(1, r.height - window.innerHeight);
      const p = clamp(-r.top / total, 0, 0.9999);
      if (gl) { gl.p = p; if (gl.api) gl.api.setProgress(p); }
      const th = marks();
      let i, local;
      if (th) {
        i = th.length - 1; while (i > 0 && p < th[i]) i--;
        const a = th[i], b = i + 1 < th.length ? th[i + 1] : 1;
        local = clamp((p - a) / Math.max(0.001, b - a), 0, 1);
      } else { i = Math.min(n - 1, Math.floor(p * n)); local = p * n - i; }
      if (i !== cur) {
        frames.forEach((f, k) => { f.classList.toggle('is-on', k === i); f.classList.toggle('is-past', k < i); });
        steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
        dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
        if (num) num.textContent = String(i + 1);
        cur = i;
      }
      steps.forEach((s, k) => { const bar = $('.bar i', s); if (bar) bar.style.setProperty('--w', (k < i ? 100 : k === i ? local * 100 : 0) + '%'); });
      root.style.setProperty('--hp-k', local.toFixed(3));
    };
    const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    steps.forEach((s, k) => s.addEventListener('click', () => {
      const r = track.getBoundingClientRect();
      const total = Math.max(1, r.height - window.innerHeight);
      const th = marks();
      const at = th ? th[k] + Math.min(0.06, ((k + 1 < th.length ? th[k + 1] : 1) - th[k]) * 0.4) : (k + 0.08) / n;
      window.scrollTo({ top: window.scrollY + r.top + total * at, behavior: reduceMotion ? 'auto' : 'smooth' });
    }));
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    update();
  }


  /* ---------- see the difference, POV: scrolling sweeps the VUERRA side across; the line also drags ---------- */
  function initPov(root) {
    const track = $('[data-pov-track]', root), frame = $('[data-pov-frame]', root), range = $('[data-pov-range]', root);
    if (!track || !frame) return;
    let x = 0, offset = 0, raf = 0, drag = null;
    const set = (v) => {
      x = Math.max(0, Math.min(1, v));
      frame.style.setProperty('--x', (x * 100).toFixed(2) + '%');
      frame.style.setProperty('--xn', x.toFixed(4));
      if (range) range.value = (x * 100).toFixed(1);
    };
    // scroll progress through the track, with a short hold at each end so both states can be read
    const fromScroll = () => {
      const r = track.getBoundingClientRect(), total = Math.max(1, track.offsetHeight - innerHeight);
      const p = Math.max(0, Math.min(1, -r.top / total));
      const k = Math.max(0, Math.min(1, (p - 0.14) / 0.68));
      return k * k * (3 - 2 * k);
    };
    const update = () => {
      raf = 0; if (drag) return;
      const v = fromScroll();
      if (v <= 0 || v >= 1) offset = 0;          // past either end, scrolling owns the line again
      set(v + offset);
    };
    const req = () => { if (!raf) raf = requestAnimationFrame(update); };
    if (reduceMotion) { set(0.5); } else { set(fromScroll()); window.addEventListener('scroll', req, { passive: true }); window.addEventListener('resize', req); }
    // drag: horizontal moves set the line; vertical swipes still scroll the page (touch-action: pan-y)
    const at = (e) => { const r = frame.getBoundingClientRect(); return (e.clientX - r.left) / r.width; };
    frame.addEventListener('pointerdown', (e) => { if (e.button !== 0) return; drag = { id: e.pointerId, x0: e.clientX, moved: false }; });
    frame.addEventListener('pointermove', (e) => {
      if (!drag || e.pointerId !== drag.id) return;
      if (!drag.moved && Math.abs(e.clientX - drag.x0) < 6) return;
      if (!drag.moved) { drag.moved = true; try { frame.setPointerCapture(e.pointerId); } catch (err) {} }
      set(at(e));
    });
    const end = () => { if (!drag) return; if (drag.moved && !reduceMotion) offset = x - fromScroll(); drag = null; };
    frame.addEventListener('pointerup', end); frame.addEventListener('pointercancel', end); frame.addEventListener('lostpointercapture', end);
    frame.addEventListener('click', (e) => { if (e.detail && !reduceMotion) { set(at(e)); offset = x - fromScroll(); } });
    if (range) range.addEventListener('input', () => { set(range.value / 100); if (!reduceMotion) offset = x - fromScroll(); });
  }

  const boot = () => {
    $$('[data-hero]').forEach(initHero);
    $$('[data-xv]').forEach(initExploded);
    $$('[data-mv]').forEach(initMaterial);
    $$('[data-lab]').forEach(initLab);
    $$('[data-tabs]').forEach(initTabs);
    $$('[data-mag]').forEach(initMag);
    $$('[data-guide]').forEach(initGuide);
    $$('[data-product-form-root]').forEach((r) => { new ProductForm(r); initSticky(r); });
    $$('[data-gallery]').forEach(initGallery);
    $$('[data-seq]').forEach(initSeq);
    $$('[data-ba]').forEach(initBA);
    $$('[data-pov]').forEach(initPov);
    $$('[data-blurin]').forEach(splitWords);
    $$('[data-rotate]').forEach(initRotate);
    $$('[data-dhero]').forEach(initDHero);
    $$('[data-bhero]').forEach(initBoxHero);
    $$('[data-ahero-motion]').forEach(initAHero);
    $$('[data-hp]').forEach(initHowPhotos);
    $$('[data-finder]').forEach(initFinder);
    $$('[data-faq]').forEach(initFaq);
    $$('[data-place]').forEach(initPlacement);
    initWords(); initReveal(); initCount(); initSpot(); initAmb();
    CartUI.bind();
    CartUI.loadUpsell().then(() => Cart.fetch()).catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
